import { openValuationDateModal } from '../../../State/valuationDateModal'

export default () => (dispatch, getState) => {

  const { project } = getState().screens.ProjectView

  dispatch(openValuationDateModal({ project }))

}
